import GoalAccountDetailContainer, {
    GoalAccountDetailContainerProps,
} from './GoalAccountDetailContainer';

const GoalAccountDetailDrawer = ({
    id,
    onClose,
}: GoalAccountDetailContainerProps) => {
    return <GoalAccountDetailContainer id={id} onClose={onClose} />;
};

export default GoalAccountDetailDrawer;
